module.exports = __webpack_public_path__ + "img/l22_pad.af85c41f.jpg";